import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() => ({
  ctaContainer: {
    display: "flex",
    justifyContent: "flex-start",
  },
  tableContainer: {
    height: "calc(100% - 100px)",
  },
  iconContainer: {
    display: "inline-block",
    cursor: "pointer",
  },
  firmwareModal: {
    height: 500,
  },
}));
